<div class="header-bar">
  <h1>Job Tag</h1>
</div>
<div class="content-container">
  <div class="">
    <form (ngSubmit)="search()" style="width: 100%">
      <div class="ui-g filterPanel form-group">
        <div class="ui-g-12 ui-md-4 adjustment_filter">
          <span class="md-inputfield filterItem">
            <input
              name="description"
              type="text"
              pInputText
              [(ngModel)]="filterVal.filters.description.value"
            />
            <label>Description</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-4 adjustment_filter">
          <button pButton type="submit" label="Search"></button>
          <button pButton type="button" label="Clear" (click)="clearFilter(dataTable)"></button>
        </div>
      </div>
    </form>

    <p-table
      #dataTable
      selectionMode="single"
      [value]="page.items"
      [lazy]="true"
      [rows]="10"
      [responsive]="true"
      [paginator]="true"
      rowHover="true"
      resizableColumns="true"
      [totalRecords]="page.total"
      (onLazyLoad)="onGridLazyLoad($event)"
      (onRowSelect)="onRowSelect($event)"
      [rowsPerPageOptions]="[5, 10, 20]"
      [pageLinks]="3"
      [(selection)]="selectedItem"
      [hidden]="!isLoaded"
    >
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="2">
            <div class="p-2 text-center"><h3>No records found</h3></div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="description">Description</th>
          <th style="width: 10%" pSortableColumn="isActive">Active</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr (dblclick)="onRowDblclick(item)" [pSelectableRow]="item">
          <td>{{ item.description }}</td>
          <td style="width: 10%">
            <p-checkbox [(ngModel)]="item.isActive" binary="true" [disabled]="true"></p-checkbox>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!--- DATATABLE DEPRECATED ---
    <p-dataTabl #dataTable selectionMode="single" [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true" [paginator]="true"
        rowHover="true" resizableColumns="true" [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" (onRowSelect)="onRowSelect($event)"
        (onRowDblclick)="onRowDblclick($vent)" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3" [(selection)]="selectedItem"
        [hidden]="!isLoaded">
        <p-column field="description" header="Description" [sortable]="tru" [editable]="false" [style]="{'width': '90%'}"></p-column>
        <p-column field="isActive" header="Active" [sortable]="tru" [editable]="false" [style]="{'width': '10%'}">
            <ng-template let-row="rowData" let-index="rowIndex" let-col pTemplate="body">
                <p-checkbox [(ngModel)]="row[col.field]" binary="true" [disabled]="true"> </p-checkbox>
            </ng-template>
        </p-column>
    </p-dataTable>
    --->

    <div class="footerPanel ui-grid-row">
      <button
        type="button"
        pButton
        (click)="onEdit()"
        label="Edit"
        icon="fa ui-icon-mode-edit"
        class="btn-to-right"
        [disabled]="!selectedItem"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-add"
        (click)="showDialogToAdd()"
        label="Add"
        class="btn-to-right"
      ></button>
    </div>

    <p-dialog
      header="Job Tag"
      [(visible)]="displayDialog"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '400px' }"
    >
      <form [formGroup]="newJobTagForm" (ngSubmit)="save(newJobTagForm.value)" autocomplete="off">
        <div class="ui-grid ui-grid-responsive ui-fluid" *ngIf="jobTag">
          <div class="ui-g-12">
            <div class="ui-g-4">
              <label for="description">Description</label>
            </div>
            <div class="ui-g-8">
              <input
                pInputText
                id="description"
                name="description"
                formControlName="description"
                maxlength="25"
              />
            </div>
            <div
              class="ui-g-12"
              [hidden]="!description.hasError('serverValidate') || description.untouched"
              style="color: red"
            >
              Description must be unique
            </div>
          </div>
          <div class="ui-g-12" style="padding: 5px">
            <div class="ui-g-4">
              <label for="isActive">Active</label>
            </div>
            <div class="ui-g-8">
              <p-checkbox id="isActive" binary="true" formControlName="isActive"></p-checkbox>
            </div>
          </div>
        </div>

        <div>
          <button
            type="button"
            class="btn-to-right"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            (click)="close()"
          ></button>
          <button
            type="submit"
            class="green-btn btn-to-right"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            [disabled]="newJobTagForm.invalid"
          ></button>
        </div>
      </form>
    </p-dialog>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
